import { html, LitElement } from 'lit-element';
import {
  mapResponseBlock,
  mapHeaderBlock,
  LayoutMethods,
  getItemConfigElement,
} from './classifier/utils.js';

/**
 * @element ct-sub-group
 * @prop {Number} index - index of subgroup in a group
 * @prop {Number} studentsAnsweredNr - The number of all the student that answered the question
 * @prop {Object} itemConfig - item config
 * @prop {Object} layout - layout type: row/column
 * @prop {Object} subgroup - Group of sessions
 */
export class CTSubGroup extends LitElement {
  static get properties() {
    return {
      index: { type: Number, attribute: false },
      layout: { type: String, attribute: false },
      itemConfig: { type: Object, attribute: false },
      studentsAnsweredNr: { type: Number, attribute: false },
      subgroup: { type: Object, attribute: false },
    };
  }

  constructor() {
    super();

    this.layout = LayoutMethods.ROW;
  }

  createRenderRoot() {
    return this;
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);

    const { element, models } = getItemConfigElement(this.itemConfig);
    const { headers } = this.subgroup || {};

    const header = headers && headers[0];
    const model = models && models[0];

    if (!element || !model) return html``;

    const { correctnessGroup } = header || {};

    // any session
    const headerTag = mapHeaderBlock({
      config: this.itemConfig,
    });
    const responseTag = mapResponseBlock({
      config: this.itemConfig,
      correctnessGroup,
    });

    if (!this.headerTag && headerTag) {
      this.headerTag = headerTag;

      this.requestUpdate('headerTag');
    }

    if (!this.responseTag && responseTag) {
      this.responseTag = responseTag;

      this.requestUpdate('responseTag');
    }

    return true;
  }

  render() {
    const { headers, sessions } = this.subgroup || {};
    const { element, models } = getItemConfigElement(this.itemConfig);
    const { elements } = this.itemConfig || {};
    let { markup } = this.itemConfig || {};

    markup = markup || '';

    const isRow = this.layout === LayoutMethods.ROW;
    const layoutClass = this.index === 0 || isRow ? 'first' : '';

    const header = headers && headers[0];
    const model = models && models[0];

    if (!element || !model || !this.headerTag || !this.responseTag) {
      return html``;
    }

    const headerProps = {
      item: model,
      session: header,
      studentsNumber: Object.keys(sessions || {}).length,
      studentsAnsweredNr: this.studentsAnsweredNr,
    };

    return html`
      <div class="ct-subgroup ${layoutClass}">
        ${this.headerTag(headerProps)}
        ${Object.values(sessions || {}).map(session => {
          const { student } = session || {};
          let { data } = session || {};

          data = data || [];

          let responseProps;

          // for multi-items, we send the data and parse it in the response blocks
          if (data && models.length > 1) {
            responseProps = {
              item: { models, markup, elements },
              sessionData: data,
              student,
            };
          } else {
            // for single-items, we send only corresponding data
            const sessionData = data.find(
              ({ id: sessDataId }) => sessDataId === model.id
            );

            responseProps = {
              item: model,
              sessionData,
              student,
            };
          }

          return this.responseTag(responseProps);
        })}
      </div>
    `;
  }
}

export default CTSubGroup;
